<template>
  <span
    class="campsite-party"
    :class="{ 'with-converted-child-ages': hasConvertedChildren }"
  >
    <span class="campsite-party-text-container">
      <translate
        v-if="hasChildren"
        :tt="{ adults, childrenCount, ages: agesDisplay }"
      >
        {adults} adults and {childrenCount} children (aged: {ages})
      </translate>
      <translate v-else :tt="{ adults }">{adults} adults</translate
      ><template v-if="hasDogs"
        >,
        <translate :tt="{ dogs }" class="dogs">
          {dogs} dogs
        </translate> </template
      ><template v-if="hasConvertedChildren"
        >&nbsp;
        <translate :tt="{ minAdultAge }" class="converted-ages"
          >(listing defines adults as age {minAdultAge}+)</translate
        >
      </template>
    </span>
  </span>
</template>

<script lang="ts">
import { Party } from '../types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteParty extends Vue {
  @Prop({ required: true })
  party: Party

  @Prop()
  minAdultAge: number

  get adults() {
    return this.party.adults + this.convertedChildrenToAdult
  }

  get dogs() {
    return this.party.dogs || 0
  }

  get childrenCount() {
    return this.party.childAges.length - this.convertedChildrenToAdult
  }

  get ages() {
    return this.party.childAges.filter((age) => age < this.minAdultAge)
  }

  get agesDisplay() {
    return this.ages.join(', ')
  }

  get hasDogs() {
    return this.dogs > 0
  }

  get hasChildren() {
    return this.childrenCount > 0
  }

  get hasConvertedChildren() {
    return this.convertedChildrenToAdult > 0
  }

  get convertedChildrenToAdult() {
    return this.party.childAges.length - this.ages.length
  }
}

export default toNative(CampsiteParty)
</script>
